<template>
  <div id="lote-minimo">
    <div @click="dialog = true">
      <slot name="ativador">
        <div class="d-flex align-center text-truncate">
          <span>Lote Mínimo</span>
          <v-icon size="15" small>mdi-pencil</v-icon>
        </div>
      </slot>
    </div>
    <div id="dialog">
      <v-dialog v-model="dialog" width="400" persistent content-class="bra-20">
        <v-card>
          <v-card-title primary-title class="pl-6 py-3">
            <span>Lote Mínimo&nbsp;</span>
            <v-spacer />
            <v-btn color="#111" icon @click="fechar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="">
            <v-text-field
              outlined
              v-model="item.loteMinimo"
              label="Quantidade para lote mínimo*"
              v-currency="number"
              class="mt-4"
              :suffix="produto.unidade_compra"
              :error-messages="loteMinimoErrors"
              @focus="$event.target.select()"
              @input="$v.item.loteMinimo.$touch()"
              @blur="$v.item.loteMinimo.$touch()"
              @keyup.enter="alterarLoteMinimo()"
            ></v-text-field>
          </v-card-text>

          <v-card-actions class="mt-n5">
            <v-spacer />
            <v-btn color="primary" text @click="alterarLoteMinimo">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ProdutoAPI from "../../../api/produto";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    produto: Object
  },
  data: () => ({
    dialog: false,
    item: {
      loteMinimo: "",
    },
    number: {
      currency: null,
      distractionFree: { hideCurrencySymbol: false },
      precision: 4,
      allowNegative: false,
      valueAsInteger: false,
      autoDecimalMode: false,
    },
  }),

  validations: {
    item: {
      loteMinimo: {
        required,
        valorValido() {
          const loteMinimo = this.semMascara(this.item.loteMinimo);

          if (loteMinimo > 0) {
            return true;
          } else {
            return false;
          }
        },
      },
    },
  },

  computed: {
    loteMinimoErrors() {
      const errors = [];
      if (!this.$v.item.loteMinimo.$dirty) return errors;
      !this.$v.item.loteMinimo.required && errors.push("Campo Obrigatório.");
      !this.$v.item.loteMinimo.valorValido &&
        errors.push("Valor deve ser superior a 0.");
      return errors;
    },
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.item.loteMinimo = this.Helpers.formatarValor(
          this.produto.lote_minimo
        );
      }
    },
  },

  methods: {
    semMascara(valor = "0") {
      return valor.replace(/[^0-9,]*/g, "").replace(",", ".");
    },
    fechar: function () {
      this.$v.$reset();
      this.dialog = false;
    },
    alterarLoteMinimo: function () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.produto.id_grupo,
          filial: this.produto.filial,
          fornecedor: this.produto.idfornecedor,
          produto: this.produto.idproduto,
          produtos: this.produto.produtos,
          lote_minimo: this.semMascara(this.item.loteMinimo),
          produto_eh_combinacao: this.produto.produto_eh_combinacao,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ProdutoAPI.setLoteMinimo(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.dialog = false;

              this.$emit("alterou-lote-minimo");
              this.$store.dispatch("tabelaProduto/setSimularClickProduto");
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>
